import type { PhraseItem } from '../types';
import { coursePlanLessons } from './coursePlan';

const starters = {
  Beginner: ['I need', 'This is', 'Can you help me with', 'I can say'],
  A1: ['Could you please explain', 'I would like to talk about', 'My answer is about', 'The main detail is'],
  A2: ['The problem started when', 'I would suggest', 'In my experience', 'Could you tell me more about'],
  B1: ['In my opinion', 'One possible solution is', 'The main advantage is', 'I partly agree because'],
  B2: ['A key factor to consider is', 'On balance, I would argue that', 'The evidence suggests that', 'This raises the question of'],
  C1: ['It is worth emphasising that', 'A more nuanced interpretation is that', 'This appears to indicate that', 'The broader implication is that'],
} as const;

export const phraseItems: PhraseItem[] = coursePlanLessons.flatMap((lesson) =>
  starters[lesson.level].map((starter, index) => {
    const phrase = `${starter} ${lesson.category}.`;
    return {
      id: `p-${lesson.id}-${index + 1}`,
      phrase,
      russian: `Полезная фраза для темы "${lesson.title}": ${phrase}`,
      context: `Use this in ${lesson.topic}.`,
      level: lesson.level,
      category: lesson.category,
      example: index === 0 ? lesson.example.en : `${phrase} ${lesson.example.en}`,
    };
  })
);
